// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"54":"420bd51f","647":"01f8a9a4"}[chunkId] + ".js";
};